import React from 'react';
import PropTypes from 'prop-types';
import useStoreSession from '../useStoreSession';
import useGuest from '../useGuest';

/**
 * Authentication callback route
 * @param {Object} history
 * @returns {function}
 * @constructor
 */
const AuthCallback = ({ history }) => {
  useGuest(history);
  useStoreSession();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        height: '100vh',
        fontFamily: 'sans-serif',
      }}
    >
      <h1>Redirecting...</h1>
    </div>
  );
};

AuthCallback.defaultProps = {
  history: null,
};

AuthCallback.propTypes = {
  history: PropTypes.object,
};

export default AuthCallback;
